export class InventoryModel {
  public date: string;
  public from: string;
  public to: string;
  public user: string;
  public sid:string;
  public serial:string;
  public status:string;
  public id: number;
  public fromDate: Date;
  public toDate: Date;

}
